export const TemplateObj = {
  10000: {
    title: "차근차근, 단계적인 회고",
    templateName: "KPT",
    imageUrl: "https://kr.object.ncloudstorage.com/layer-bucket/template/0908_kpt.png",
  },
  10001: {
    title: "성장부터 성찰까지, 올인원 회고",
    templateName: "5F",
    imageUrl: "https://kr.object.ncloudstorage.com/layer-bucket/template/0908_5F.png",
  },
  10002: {
    title: "감정 통찰을 위한 회고",
    templateName: "Mad Sad Glad",
    imageUrl: "https://kr.object.ncloudstorage.com/layer-bucket/template/0908_madsadglad.png",
  },

  10003: {
    title: "상태 파악을 위한 회고",
    templateName: "SSC",
    imageUrl: "https://kr.object.ncloudstorage.com/layer-bucket/template/0908_SSC.png",
  },
  10004: {
    title: "단순하지만 명확한 회고",
    templateName: "PMI",
    imageUrl: "https://kr.object.ncloudstorage.com/layer-bucket/template/0908_PMI.png",
  },
  10005: {
    title: "내가 직접 만드는 회고",
    templateName: "무제",
    imageUrl: "https://kr.object.ncloudstorage.com/layer-bucket/template/0908_untitled.png",
  },
};

export type TemplateKey = keyof typeof TemplateObj;
